import PropTypes from 'prop-types';
import React from 'react';
import ArrayTabFiles from '../mediasPages/ArrayTabFiles';
import MediaCardTemplate from './MediaCardTemplate';
import { useGetCampagneReqQuery } from '../../../../redux/api/cache';

export default function PlanificationProduitFactory(props) {
  const { data, isLoading } = useGetCampagneReqQuery({ seq: props.data.camp_seq, media: props.media.key });

  const TwoGroupBy = (
    <ArrayTabFiles
      data={data}
      project={props.data}
      mediaKey={props.media.key}
      documentUrlParameters={[{ label: 'Diffuseur', key: 'diff_cd', uri: 'diff' },
      { label: 'Thématique', key: 'them_cd', uri: 'them' },
      { label: 'Date', key: 'campr_date', uri: 'date' }, { label: 'Format', key: 'mf_format', uri: 'mf_format' }]}
    />
  );

  return (
    <MediaCardTemplate isLoaded={!isLoading} card={props.card} data={data}>
      {TwoGroupBy}
    </MediaCardTemplate>
  );
}

PlanificationProduitFactory.propTypes = {
  card: PropTypes.shape({
    type_url: PropTypes.any,
  }),
  data: PropTypes.shape({
    camp_seq: PropTypes.any,
  }),
  media: PropTypes.shape({
    key: PropTypes.any,
  }),
};
